import * as helpers from './helpers'

export const theme = {
  border: {
    none: '0',
    '1px': '1px solid',
    '2px': '2px solid',
    '4px': '4px solid',
    '8px': '8px solid',
  },
  helpers,
  colors: {
    altovita: '#13295B',
    primary: '#1E3A8A',
    primaryDefault: '#13295B',
    primaryHover: '#25386F',
    disabled: '#F5F7FA',
    primaryLoading: '#F5F7FA',
    secondaryDefault: '#FFFFFF',
    secondaryHover: '#EEF2F6',
    greyText: '#3E537A',
    lightBg: '#F5F7FA',
    borderColor: '#D6DBE5',
    error: '#EF4444',
    footerShadow: 'rgba(19, 41, 91, 0.08)',

    successBg: '#F0FDF4',
    successText: '#166534',
    successBorder: '#BBF7D0',
    errorBg: '#FEF2F2',
    errorText: '#991B1B',
    errorBorder: '#FECACA',
    infoBg: '#EFF6FF',
    infoText: '#1E40AF',
    infoBorder: '#BFDBFE',
    warningBg: '#FEFCE8',
    warningText: '#854D0E',
    warningBorder: '#FEF08A',
    paleRed: '#EDE4E5',
    paleGreen: '#D9F0C2',
    abiBlue: '#619EFF',
    apricotIllusion: '#E3C5A7',
    fossilTan: '#D0B090',
    coastalFjord: '#4F5B7F',
    altoVitaMain: '#162958',
    aircraftWhite: '#EFF2F6',
    angeliqueGrey: '#D9DFE7',
    artichokeyHeart: '#E4D688',
    athensGray: '#FAFBFC',
    babyFrog: '#C7B862',
    black: '#000000',
    blueAura: '#6B7386',
    blueBerryBuckle: '#8895B4',
    blueDepths: '#273966',
    blueExpanse: '#1F3973',
    blueSparkle: '#007AFF',
    catsBorderColor: '#C4CDD6',
    catskillWhite: '#EEF2F6',
    causeway: '#6E778C',
    childOfLight: '#F0F3F7',
    chimneySweep: '#242E39',
    crystalBay: '#DBE1E8',
    danger: '#F36767',
    diminishedLime: '#EEF7E0',
    distantWindChime: '#EBEEF1',
    dryHighlighterGreen: '#31B11C',
    doctor: '#F8F9FB',
    drowsyLavender: '#D5DBE1',
    errigalWhite: '#F1F2F4',
    featherSoftBlue: '#A1AEBE',
    fibonacciBlue: '#142A5A',
    fiveStar: '#FFAB49',
    flameOrange: '#F58B29',
    floralWhite: '#FFF8F0',
    greenette: '#D9ECC7',
    herringSilver: '#C5CACF',
    jocoseJade: '#6FCF97',
    khmerCurry: '#EC5555',
    lavenderSteel: '#C5CBDA',
    libertyBlue: '#09142E',
    lilliputianLime: '#91DE59',
    madderBlue: '#B6B8CD',
    magicalMerlin: '#3688D3',
    nocturnal: '#777D84',
    frilledShark: '#959EA8',
    opalFlame: '#F25E4A',
    orbOfHarmony: '#EDDC42',
    ottomanRed: '#EF2222',
    orochimaru: '#d9d9d9',
    pigeonPost: '#A6B9DF',
    pinwheelGeyser: '#D4DBDE',
    retroMint: '#A4B2D4',
    sapphire: '#142A5B',
    sapphireDark: '#13295B',
    second: '#4F5B7F',
    sefidWhite: '#FFF2F2',
    sephirothGrey: '#8991AA',
    shockingCrimson: '#FF0808',
    showFlake: '#F0F0F0',
    skirretGreen: '#53C249',
    slateGray: '#747C94',
    smokeyDenim: '#737C94',
    solitude: '#E9ECF2',
    spaceGrey: '#F6F8FA',
    spinelStoneBlack: '#242B3E',
    titleHover: '#3A5FBA',
    touchOfMint: '#F9FFF9',
    ultramarineViolet: '#162958',
    violetWater: '#D2D7E4',
    white: '#FFFFFF',
    windjammer: '#64AAE4',
    zhenZhuBaiPearl: '#f7f9fb',
    megaMetalPhoenix: '#c5cad5',
    cautiousBlue: '#d6dbe5',
    coralRed: '#C61818',
    vividOrange: '#DA7111',
    buttercupGlow: '#DBC504',
    verdantFields: '#1FAA14',
    mediterraneanSwirl: '#2A93AA',
    sunflowerMango: '#FFB700',
    shiningKnight: '#969EA7',
    breadPudding: '#BDA472',
    starAndCrescentRed: '#C22020',
    creamyCloudDreams: '#FFF6E0',
    whiteCotton: '#F3F9FD',
    whiteSolid: '#F5F7FA',
    devonshire: '#F4EFE7',
    aliceBlue: '#F0F7FF',
    ballerinaGown: '#FAE9E9',
    lynxScreenBlue: '#32ADE6',
    venetianNights: '#7B61FF',
    pumpkinSoup: '#DF7C08',
    northTexasGreen: '#109934',
    lavenderPhlox: '#A6B9DF',
    bloodKiss: '#C60C0C',
    jacarandaPink: '#C45DFF',
    placeboPurple: '#F3EBFC',
    pineappleSorbet: '#F7F4DB',
    celestialCathedral: '#DBE8F7',
    cabbageLeaf: '#DDE9D2',
    verdunGreen: '#425820',
    veryCoffee: '#6A4914',
    damask: '#FDF3E0',
    purpleOde: '#3E537A',
    negativeBg: '#FBF3EF',
    negativeDark: '#952F18',
    graph1: '#13295B',
    graph2: '#007AFF',
    graph3: '#A6CA84',
    graph4: '#FF6847',
    graph5: '#E6D063',
    graph6: '#C45DFF',
    graph7: '#F39536',
    graph8: '#667EB9',
    graph9: '#C8A876',
    graph10: '#C5CBDA',
    accent1Dark: '#0065D1',
    alertDark: '#6A4914',
    alertBg: '#FEFAEC',
    positiveDark: '#345714',
    positiveBg: '#EBF7E0',
    cloudBreak: '#f9efff',
    brilliantWhite: '#e5f2ff',
    antiqueLace: '#fdf3dc',
    jellySlug: '#e16449',
    festivalGreen: '#6CA03B',
    moonDust: '#E0E7EF',
    momsPancake: '#f5c250',
    caribbeanBlue: '#00ADEF',
    highBlue: '#4DAAE9',
    greyText2: '#5D7299',
  },
  radius: {
    none: '0',
    sm: '2px',
    base: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
    '2xl': '16px',
    '3xl': '24px',
    full: '9999px',
    default: '8px',
    big: '16px',
  },
  fonts: {
    mainFont: 'DINPro, Helvetica, Arial, sans-serif',
    itcGothicPro:
      '"ITCGothicPro", "DINPro", "D-DIN", Helvetica, Arial, sans-serif',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
  },
  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
  },
  fontWeight: {
    thin: 100,
    extraLight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    heavy: 900,
  },
  animationSpeed: {
    fast: '100ms',
    medium: '300ms',
    slow: '700ms',
  },
}
